import { getAuctionCatalogue } from './auctionCatalogueClient';

export const getVersionsWithAuctions = async (context = {}, brandId, modelId, yearId, options) => {
  if (!brandId || !modelId || !yearId) return [];
  return getAuctionCatalogue('getVersionsWithAuctionsV2', context, {brandId, modelId, yearId}, options);
};
